// ═══════════════════════════════════════════════════════════════
// Iter 250 · Feb 2026 — iPad Version Badge
// Karine's ask: "show the running JS build hash in the footer so a
// stale iPad cache after deploy is spotted in one glance."
//
// Strategy:
//   • In production CRA emits `/static/js/main.<HASH>.chunk.js` and
//     `/static/js/<N>.<HASH>.chunk.js`. We scan the currently loaded
//     <script> tags on the page and pull the first hash we find in a
//     main.*.chunk.js URL.
//   • In dev mode CRA emits `bundle.js` (no hash) — we surface "dev"
//     so it's obvious you're on the preview and not production.
//   • We also compute a short human-readable "loaded at" timestamp so
//     someone can eyeball whether the tab has been up for hours.
// ═══════════════════════════════════════════════════════════════

function readBundleHash() {
  if (typeof document === "undefined") return "srv";
  try {
    const scripts = Array.from(document.querySelectorAll("script[src]"));
    // 1) Preferred: production main.<hash>.chunk.js  (CRA 4/5)
    for (const s of scripts) {
      const m = /\/static\/js\/main\.([a-f0-9]{6,20})\.(?:chunk\.)?js/i.exec(s.src || "");
      if (m) return m[1].slice(0, 8);
    }
    // 2) Fallback: ANY hashed chunk.js
    for (const s of scripts) {
      const m = /\/static\/js\/[\w-]+\.([a-f0-9]{6,20})\.(?:chunk\.)?js/i.exec(s.src || "");
      if (m) return m[1].slice(0, 8);
    }
    // 3) Dev mode — CRA emits /static/js/bundle.js
    for (const s of scripts) {
      if (/\/static\/js\/bundle\.js/i.test(s.src || "")) return "dev";
    }
  } catch (_e) { /* noop */ }
  return "unknown";
}

// Computed ONCE at module-load. Any consumer just imports the constants.
export const BUILD_HASH = readBundleHash();

// ISO string trimmed to minute — "2026-02-05 23:41"
export const LOADED_AT = (() => {
  const d = new Date();
  const pad = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
})();
